import React from 'react';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from '../../../_ui/Modal/Modal';
import Button from '../../../_ui/Button/Button';
import { deleteEmail } from '../ReportsPageDucks';

function ReportsSettingDeleteEmailModal({ data, close, reloadPage }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <Modal title={t('reportsPage_deleteEmailModal')} open onClose={close}>
      <DialogContent>{t('reportsPage_deleteEmailConfirmText')}</DialogContent>
      <DialogActions>
        <Button text={t('reportsPage_cancelBtn')} onClick={close} />
        <Button
          text={t('reportsPage_deleteEmailBtn')}
          onClick={() => dispatch(deleteEmail(data, reloadPage, close))}
        />
      </DialogActions>
    </Modal>
  );
}

export default ReportsSettingDeleteEmailModal;
